var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05654 0.546853C1.57724 0.0638093 2.42146 0.0638093 2.94216 0.546853L9.99935 7.09369L17.0565 0.546853C17.5772 0.0638093 18.4215 0.0638093 18.9422 0.546853C19.4629 1.0299 19.4629 1.81307 18.9422 2.29611L11.885 8.84295L18.9422 15.3898C19.4629 15.8728 19.4629 16.656 18.9422 17.139C18.4215 17.6221 17.5772 17.6221 17.0565 17.139L9.99935 10.5922L2.94216 17.139C2.42146 17.6221 1.57724 17.6221 1.05654 17.139C0.535841 16.656 0.535841 15.8728 1.05654 15.3898L8.11373 8.84295L1.05654 2.29611C0.535841 1.81307 0.535841 1.0299 1.05654 0.546853Z",
    fill: "#3F3F55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/iconClose.62c51edfa953e0bb6f55b98c85145ca0.svg";
export { ForwardRef as ReactComponent };